export const BRAZIL_STATES = [
  { code: '12', uf: 'AC', name: 'Acre' },
  { code: '27', uf: 'AL', name: 'Alagoas' },
  { code: '16', uf: 'AP', name: 'Amapá' },
  { code: '13', uf: 'AM', name: 'Amazonas' },
  { code: '29', uf: 'BA', name: 'Bahia' },
  { code: '23', uf: 'CE', name: 'Ceará' },
  { code: '53', uf: 'DF', name: 'Distrito Federal' },
  { code: '32', uf: 'ES', name: 'Espírito Santo' },
  { code: '52', uf: 'GO', name: 'Goiás' },
  { code: '21', uf: 'MA', name: 'Maranhão' },
  { code: '51', uf: 'MT', name: 'Mato Grosso' },
  { code: '50', uf: 'MS', name: 'Mato Grosso do Sul' },
  { code: '31', uf: 'MG', name: 'Minas Gerais' },
  { code: '15', uf: 'PA', name: 'Pará' },
  { code: '25', uf: 'PB', name: 'Paraíba' },
  { code: '41', uf: 'PR', name: 'Paraná' },
  { code: '26', uf: 'PE', name: 'Pernambuco' },
  { code: '22', uf: 'PI', name: 'Piauí' },
  { code: '33', uf: 'RJ', name: 'Rio de Janeiro' },
  { code: '24', uf: 'RN', name: 'Rio Grande do Norte' },
  { code: '43', uf: 'RS', name: 'Rio Grande do Sul' },
  { code: '11', uf: 'RO', name: 'Rondônia' },
  { code: '14', uf: 'RR', name: 'Roraima' },
  { code: '42', uf: 'SC', name: 'Santa Catarina' },
  { code: '35', uf: 'SP', name: 'São Paulo' },
  { code: '28', uf: 'SE', name: 'Sergipe' },
  { code: '17', uf: 'TO', name: 'Tocantins' }
];

export const getStateByCode = (code) =>
  BRAZIL_STATES.find((state) => state.code === code);

export const getStateByUf = (uf) =>
  BRAZIL_STATES.find((state) => state.uf === uf);

const sortTotals = (items) => Object.entries(items)
  .map(([name, value]) => ({ name, value }))
  .sort((a, b) => b.value - a.value || a.name.localeCompare(b.name));

const sortErrors = (items) => Object.entries(items)
  .map(([message, value]) => ({ message, value }))
  .sort((a, b) => b.value - a.value || a.message.localeCompare(b.message));

const createBucket = (uf = 'ALL') => ({
  uf,
  total: 0,
  statuses: {},
  errors: {},
  severity: 0
});

const addRowToBucket = (bucket, row) => {
  const quantidade = Number(row.quantidade || 0);
  const grupo = row.grupo || 'SEM_STATUS';
  const statuses = {
    ...bucket.statuses,
    [grupo]: (bucket.statuses[grupo] || 0) + quantidade
  };
  const errors = row.errorMessage
    ? {
      ...bucket.errors,
      [row.errorMessage]: (bucket.errors[row.errorMessage] || 0) + quantidade
    }
    : bucket.errors;

  return {
    ...bucket,
    total: bucket.total + quantidade,
    statuses,
    errors
  };
};

const sumValues = (items) => Object.values(items)
  .reduce((sum, value) => sum + value, 0);

const formatBucket = (bucket) => {
  const invalidationReasonsTotal = sumValues(bucket.errors);
  return {
    ...bucket,
    statuses: sortTotals(bucket.statuses),
    errors: sortErrors(bucket.errors).slice(0, 5),
    severity: bucket.total > 0
      ? Number((invalidationReasonsTotal / bucket.total).toFixed(2))
      : 0
  };
};

export const aggregateSnapshotRows = (rows = []) => {
  const byUf = {};
  let national = createBucket();

  rows.forEach((row) => {
    const uf = row.estado;
    if (!uf) return;

    if (!byUf[uf]) byUf[uf] = createBucket(uf);
    byUf[uf] = addRowToBucket(byUf[uf], row);
    national = addRowToBucket(national, row);
  });

  Object.keys(byUf).forEach((uf) => {
    byUf[uf] = formatBucket(byUf[uf]);
  });

  return {
    byUf,
    national: formatBucket(national),
    total: national.total
  };
};

export const getSeverityFill = (severity, hasData) => {
  if (!hasData) return '#e9edf2';
  if (severity >= 0.6) return '#d95f59';
  if (severity >= 0.4) return '#f2a65a';
  return '#57b894';
};
